import { ceresCatalogTypes } from '@debijenkorf/dbk-common';

export type BreadcrumbsItem = ceresCatalogTypes.components['schemas']['Breadcrumb'];

export const homeBreadCrumb = {
  text: 'Home',
  relativeUrl: '/',
  url: '/',
};

export const formatBreadcrumbs = (breadcrumbs?: BreadcrumbsItem[]) => {
  if (!breadcrumbs?.length) return null;

  return breadcrumbs.map(({ name = '', relativeUrl = '', url = '' }) => ({
    text: name,
    relativeUrl,
    url,
  }));
};

export type FormattedBreadcrumbs = ReturnType<typeof formatBreadcrumbs>;
